module.exports = __webpack_public_path__ + "static/img/R407C.5735bc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/oem/R407C.jpg
// module id = 14ti
// module chunks = 1